import { Claim, claimSubmit } from '../../claim';
import { getLifeAssuredDetailsFromClaim } from '../../life-assured-details/reducer';
import { ReduxThunkAction } from '../../redux/redux-actions';

interface UpdateModel {
    keyTaxDirectiveDeclaration: string;
}
type UpdateClaimKeyTaxDeclarationReturn = Promise<any>;
export type UpdateClaimKeyTaxDeclaration = (
    values: UpdateModel
) => UpdateClaimKeyTaxDeclarationReturn;
type UpdateClaimKeyTaxDeclarationAction = (
    values: UpdateModel
) => ReduxThunkAction<UpdateClaimKeyTaxDeclarationReturn>;

export const updateClaimKeyTaxDeclarationAction: UpdateClaimKeyTaxDeclarationAction = (
    values: UpdateModel
) => {
    return async (dispatch, getState) => {
        return claimSubmit(dispatch, getState, getUpdatedClaim(values));
    };
};

function getUpdatedClaim(values: UpdateModel): (claim: Claim) => Claim {
    return (claim: Claim) => {
        const lifeAssuredDetails = getLifeAssuredDetailsFromClaim(claim);
        return {
            ...claim,
            lifeAssuredDetails: {
                ...lifeAssuredDetails,
                ...values,
            },
        };
    };
}
